import { render, staticRenderFns } from "./ArrobaMedellinVerticalCardIdi.html?vue&type=template&id=05d68062&scoped=true&external"
import script from "./ArrobaMedellinVerticalCardIdi.vue?vue&type=script&lang=js"
export * from "./ArrobaMedellinVerticalCardIdi.vue?vue&type=script&lang=js"
import style0 from "./ArrobaMedellinVerticalCardIdi.scss?vue&type=style&index=0&id=05d68062&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d68062",
  null
  
)

export default component.exports